
































import { Component, Vue } from 'vue-property-decorator';
import { 認証型 } from '@/type/authentication/authentication';
import { progress } from '@/script/progress';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import {トーショー納入明細出力条件型} from '@/type/custom/otaru/tosho/recievedetail';
import {出力条件バリデータマップ一覧} from '@/type/custom/otaru/tosho/validation';
import {ValidationResult} from '@/type/validation/result';

@Component({
  components: {
    IconButton,
    ButtonPanel,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    Datepicker,
  },
})
export default class RecieveDetail extends Vue {

  private アラートメッセージ: string | string[] | null = null;
  private バリデータ: ValidationResult = new ValidationResult(出力条件バリデータマップ一覧);

  private 出力条件: トーショー納入明細出力条件型 = {
    出力対象開始日: null,
    出力対象終了日: null,
  };

  private download() {
    this.バリデータ.validate(this.出力条件);
    if (this.バリデータ.hasErrors) {
      const メッセージ = this.バリデータ.getMessages();
      this.アラートを表示する(メッセージ);
      return;
    }
    this.ダイアログを開く('小樽市民病院CSVダウンロード確認ダイアログ');
  }

  private clear() {
    this.出力条件 = {
      出力対象開始日: null,
      出力対象終了日: null,
    };
  }

  private async ダウンロードするハンドラ() {
    this.ダイアログを閉じる('小樽市民病院CSVダウンロード確認ダイアログ');
    progress(this.ダウンロードする);
  }

  private async ダウンロードする() {
    await download.トーショー納入明細CSVを出力する('納入明細データ.csv', this.出力条件)
      .catch(this.サーバリクエストエラートラップ);
  }

  private ダイアログを開く(name: string): void {
    this.$modal.show(name);
  }

  private ダイアログを閉じる(name: string): void {
    this.$modal.hide(name);
  }

  private アラートを表示する(メッセージ: string | string[]) {
    this.アラートメッセージ = メッセージ;
    this.$modal.show('小樽市民病院CSVダウンロードアラートダイアログ');
  }

  private サーバリクエストエラートラップ(error: any) {
    if (!error) {
      this.アラートを表示する('エラーが発生しました。');
      return;
    }
    if (!error.status) {
      this.アラートを表示する('通信に失敗しました。');
      return;
    }
    if (error.status < 400 || error.status >= 500) {
      this.アラートを表示する('サーバーでエラーが発生しました。');
      return;
    }
    if (!error.data) {
      this.アラートを表示する('サーバーでエラーが発生しました。');
      return;
    }
    if (error.data.errors) {
      const メッセージ = error.data.errors;
      this.アラートを表示する(メッセージ);
      return;
    }
    if (error.data.message) {
      this.アラートを表示する(error.data.message);
      return;
    }
    this.アラートを表示する('エラーが発生しました。');
  }
}
